import script from "./theBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./theBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./theBreadcrumbs.vue?vue&type=style&index=0&id=4df2dc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df2dc72"]])

export default __exports__